export function isDev() {
  return process.env.NODE_ENV === "dev" || process.env.REACT_APP_ENV === "dev";
}